import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import MultiSelect from '../../../misc/Multiselect';

const StyledWrapper = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  ${(props) => (typeof props.margin === 'number' ? `padding: ${props.margin}px;` : '')}
`;

class TableMultiselectField extends React.PureComponent {

  static propTypes = {

    fieldId: PropTypes.string,
    fieldIdentifier: PropTypes.string,
    fieldPositionId: PropTypes.string,

    value: PropTypes.array,
    cellValue: PropTypes.string,
    disabled: PropTypes.bool,
    options: PropTypes.array,

    //Field style
    fontSize: PropTypes.string,
    fontStyle: PropTypes.string,
    fontWeight: PropTypes.string,
    textAlign: PropTypes.string,
    textTransform: PropTypes.string,
    textDecoration: PropTypes.string,
    margin: PropTypes.number,
    backgroundColor: PropTypes.string,
    borderColor: PropTypes.string,
    borderWidth: PropTypes.number,
    borderRadius: PropTypes.number,
    primaryColor: PropTypes.string,

    //Action handlers
    onChange: PropTypes.func,
    onFocus: PropTypes.func,
    onBlur: PropTypes.func,

  }

  render() {

    const {
      fieldId,
      fieldIdentifier,
      fieldPositionId,

      cellValue,
      disabled,
      options,
      fontSize,
      fontStyle,
      fontWeight,
      textAlign,
      textTransform,
      textDecoration,
      borderColor,
      borderWidth,
      borderRadius,
      primaryColor,
      backgroundColor,
      margin,

      //Action handlers
      onFocus,
      onBlur,

      tableColumns,
      rowOrder,
      rowIndex,
      tabIndex,
      column
    } = this.props;

    const styles = {
      fontSize,
      fontStyle,
      fontWeight,
      textAlign,
      textTransform,
      textDecoration,
    };

    const tableCellColumn = tableColumns && tableColumns.length > 0 ? tableColumns.find((item) => item._id === column) : {};

    const tableCellRowId = rowOrder && rowOrder.length > 0 ? rowOrder[rowIndex] : '';

    const tableCellColumnIdentifier = tableCellColumn && Object.keys(tableCellColumn).length > 0 ? tableCellColumn.identifier : '';

    const formattedOptions = options
      .filter((opt) => !opt.deleted)
      .map((opt) => ({
        value: opt._id,
        label: opt.value,
        backgroundColor: opt.styles?.backgroundColor || '#f0f0f0',
      }));

    const selectedValues = formattedOptions.filter((opt) => cellValue?.includes(opt.value));

    const displayFieldNode = (
      <MultiSelect
        tabIndex={tabIndex}
        ref={(ref) => { this.selectRef = ref; }}
        multiple
        disabled={disabled}
        options={formattedOptions}
        value={selectedValues}
        // styles={getCustomStyles(this.props)}
        onChange={(selectedOptions) => {
          const nextValue = selectedOptions ? selectedOptions.map((opt) => opt.value) : [];
          if (!disabled && nextValue !== cellValue) this.handleCellChange(nextValue);
        }}
        onFocus={() => {
          if (!disabled && onFocus) {
            onFocus(fieldId, fieldIdentifier, fieldPositionId, {}, tableCellRowId, column, tableCellColumnIdentifier);
          }
        }}
        onBlur={() => {
          if (!disabled && onBlur) {
            onBlur(fieldId, fieldIdentifier, fieldPositionId, {}, tableCellRowId, column, tableCellColumnIdentifier);
          }
        }}
        styles={styles}
        {...{
          borderColor,
          borderWidth,
          borderRadius,
          primaryColor,
          backgroundColor,
        }}
      />
    );

    return (
      <StyledWrapper {...{ margin }}>
        {displayFieldNode}
      </StyledWrapper>
    );
  }

  handleCellChange = (nextCellValue) => {

    const { onChange, rowId, column, value, fieldId, fieldIdentifier, fieldPositionId } = this.props;

    const nextValue = [...value];
    const targetRowIndex = value.findIndex((row) => row._id === rowId);

    const nextRow = { ...nextValue[targetRowIndex] };

    /**<----------NOTICE---------------->
    * onChange will only be triggered if the row and column associated
    * with the table cell is undeleted
    */
    if (nextRow && nextRow._id) {

      nextRow.cells = { ...nextRow.cells, [column]: nextCellValue };

      nextValue[targetRowIndex] = nextRow;

      if (onChange) onChange(fieldId, fieldIdentifier, fieldPositionId, nextValue);

    }

  }
}

export default TableMultiselectField;
